import {mergeProperties} from "../components/Utility";

export const getFormData = (data) => {
    const initialData = {
        form_id: '',
        domain: '',
        name: '',
        description: ''
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown, deleteHandler}) => {

    let tableColumns = [
        {header: "Form Id", field: "formId"},
        {header: "Domain", field: "domain"},
        {header: "Name", field: "name"},
        {header: "Description", field: "description"},
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} edit={true} view={true} onDelete={deleteHandler}/>;
        },
    });
    return tableColumns;
};


export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        formId: item.form_id,
        domain: item.domain,
        name: item.name,
        description: item.description,
    }));
}

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            id: item.id,
            formId: item.form_id,
            domain: item.domain,
            name: item.name,
            description: item.description,
        }
    };
}








